import { Grid, Button } from '@mui/material';
import { MessageSuggestion } from './MessageSuggestion';
import React from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import NativeOrWeb from '../../../../../utils/native';

const useStyles = makeStyles()(theme => ({
  rationale: {
    fontSize: '1.4rem',
    color: '#959595'
  },
  datetime: {
    paddingTop: 12,
    fontSize: '1.4rem',
    color: '#999'
  },
  title: {
    fontSize: '1.6rem'
  }
}));

export const NewsSuggestionResult = props => {
  const { classes } = useStyles();
  const { onGenerate, news } = props;
  const { messages, link, title, datetime } = news;

  const rationale = messages[0].rationale;
  return (
    <Grid container spacing={2} sx={{ flexDirection: 'column' }}>
      <Grid>
        <Typography className={classes.rationale}>{rationale}</Typography>
      </Grid>
      <Grid>
        <Typography className={classes.datetime}>{datetime || ''}</Typography>
        <Typography className={classes.title}>{title}</Typography>
      </Grid>
      {messages.map((message, index) => (
        <Grid key={index} style={{ width: '100%', maxWidth: '100%' }}>
          <MessageSuggestion
            message={message.message}
            link={link}
            onShare={() => {
              NativeOrWeb.share({ text: `${message.message}\n${link}` }).catch(error => {
                console.error(error);
              });
            }}
          />
        </Grid>
      ))}
      <Grid>
        <Button
          style={{ borderRadius: 16 }}
          variant="outlined"
          color="primary"
          onClick={() => {
            onGenerate?.({ news: news });
          }}
          fullWidth
        >
          重新生成訊息
        </Button>
      </Grid>
    </Grid>
  );
};
